// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {On_view_animation} from '../ui/on_view_animation';
import {Media_block} from '../ui/media_block';
import {Editor} from '../../../shared/editor/editor';
import cn from 'classnames';
import styles from './product_browser_media.module.less';

export const Product_browser_media = ()=>{
    const {theme} = useContext(Settings_context);
    const components = {
        Link_premium: <a className={styles.text_link}
          href="https://hola.org/premium?ref=from_faq_browser_product"/>,
    };
    const anim_size = {all: [544, 444], xs: [335, 273]};
    const anim_flashlight = <On_view_animation
      cls={cn(styles.animation, styles.animation_flashlight)}
      src="animation/hp_media_flashlight.json" size={anim_size} loop
    />;
    const anim_arc = <On_view_animation
      cls={cn(styles.animation, styles.animation_arc)}
      src="animation/hp_media_arc.json" size={anim_size} loop
    />;
    return <div
      className={cn(theme.container, theme.block, styles.browser_media)}>
      <Media_block img_content={anim_arc}
        cls={{content: styles.media_content, container: styles.media_block}}
        title="hp.how_it_works.product_browser_premium.title"
        text="hp.how_it_works.product_browser_premium.text"
        components={components}/>
      <Media_block img_content={anim_flashlight}
        cls={{content: styles.media_content, container: styles.media_block}}
        title="hp.how_it_works.product_browser_free.title"
        text="hp.how_it_works.product_browser_free.text"
        components={components} reversed/>
    </div>;
};

interface i_product_browser_media_editor_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const Product_browser_media_editor = (
{value, on_change}: i_product_browser_media_editor_props
)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
